export default __webpack_public_path__ + "static/media/article.e66e65c4.jpg";